<div class="grid grid-cols-2 w-full h-screen overflow-hidden max-[1024px]:grid-cols-[60%_40%] max-[768px]:grid-cols-1">
  <div class="flex flex-col overflow-auto p-7.5 [@media(max-height:820px)]:py-4">
    <header class="flex justify-between ">
      <div class="flex ">
        <img class="w-60 h-auto" src="assets/images/logo.svg" alt="Veredis">
      </div>
      <div class="flex  justify-between">
        <app-language-selector></app-language-selector>
      </div>
    </header>
    <main class="flex-1 flex flex-col mt-10 max-[768px]:justify-center max-[768px]:items-center">
      <router-outlet />
    </main>
  </div>

  <aside class="overflow-hidden max-[768px]:hidden" aria-hidden="true">
    <img
      class="block w-full h-full object-cover"
      src="assets/images/tech.jpg"
      alt="Veredis"
    />
  </aside>
</div>
